module.exports = __webpack_public_path__ + "img/potencia_c_gray.03fa1c6a.svg";